<template>
  <WorksLoader :payload="payload" />
</template>

<script>
import WorksLoader from "@components/worksLoader/WorksLoader";
import { mapGetters } from "vuex";

export default {
  components: {
    WorksLoader
  },
  props: {
    payload: {
      default: () => {}
    }
  }
};
</script>
